import { render, staticRenderFns } from "./KpiQuestionAssignment.vue?vue&type=template&id=0c9fbdb4&scoped=true&"
import script from "./KpiQuestionAssignment.vue?vue&type=script&lang=js&"
export * from "./KpiQuestionAssignment.vue?vue&type=script&lang=js&"
import style0 from "./KpiQuestionAssignment.vue?vue&type=style&index=0&id=0c9fbdb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9fbdb4",
  null
  
)

export default component.exports